module.exports = __webpack_public_path__ + "img/home-process-2.5724c5ad.png";